<ng-container *transloco="let t; read: 'login'">
  <div class="backgroundContainer">
    <div class="wrapper">
      <div class="loginPage">
        <div class="loginComponents">
          <div class="loginLogo">
            <img src="../../../assets/images/Haenytec_Logo_invert.svg">
          </div>
          @if (isBeta) {
            <div class="developmentInfo">
              <div class="developmentInfoContainer">
                <span>Beta</span>
              </div>
            </div>
          }
          @if (isStaging) {
            <div class="developmentInfo">
              <div class="developmentInfoContainer">
                <span>Staging</span>
              </div>
            </div>
          }
          @if (!isProd && !isBeta && !isStaging) {
            <div class="developmentInfo">
              <div class="developmentInfoContainer">
                <span>Entwicklung</span>
              </div>
            </div>
          }
          <div class="loginForm">
            <form [formGroup]="loginForm" (submit)="onSubmit()">
              <input kendoTextBox
                placeholder="{{t('mandant')}}"
                class="basicInputField"
                formControlName="tendantId">

                <input kendoTextBox
                  class="basicInputField"
                  placeholder="{{t('email')}}"
                  formControlName="email">

                  <input kendoTextBox
                    class="basicInputField"
                    placeholder="{{t('password')}}"
                    type="password"
                    formControlName="password">

                    <button
                      [disabled]="loginForm.invalid"
                      type="submit"
                      kendoButton
                      fillMode="solid"
                      size="large"
                      rounded="large"
                      class="buttonPrimary"
                      [themeColor]="isLoading ? 'warning' : 'primary'">
                      {{isLoading ? t('loginInProcess') : t('login')}}
                    </button>
                    <span class="version">{{version}}</span>
                  </form>
                </div>
                <div class="loginForgot">
                  <a href="https://haenytec.ch/kontakt/" target="_blank">{{t('forgotPassword')}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
